module.exports = __webpack_public_path__ + "static/media/lips-logo-icon.91425043.svg";